'use client';

import { useCallback, useMemo, useState } from 'react';

import Eye from '../../../../../public/assets/icons/passwordEye.svg';
import { InputField, type Props as InputProps } from '../InputField';

type Props = {
	isEmpty?: boolean;
} & Omit<InputProps, 'type' | 'rightIcon' | 'onRightIconClick'>;

export const PasswordField = ({
	isEmpty = true,
	...props
}: Props & { isEmpty?: boolean }) => {
	const rightIcon = useMemo(() => (isEmpty ? undefined : <Eye />), [isEmpty]);
	const [inputType, setInputType] = useState<'text' | 'password'>('password');

	const togglePasswordVisibility = useCallback(() => {
		setInputType((prevType) => (prevType === 'password' ? 'text' : 'password'));
	}, []);

	return (
		<InputField
			{...props}
			type={inputType}
			rightIcon={rightIcon}
			onRightIconClick={togglePasswordVisibility}
		/>
	);
};
